import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { formatValue } from "../../../utilities";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const CumulativeGapBySectorChart = props => {
  const data = props.data;

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        categories={["LIC", "L-MIC", "U-MIC"]}
        series={[
          {
            name: "Donor",
            color: styleConstants.categoryColors.sectorColors["Donor"],
            data: data
              .filter(datum => datum.sector === "Donor")
              .map(datum => datum.value)
          },
          {
            name: "Gov't",
            color: styleConstants.categoryColors.sectorColors["Government"],
            data: data
              .filter(datum => datum.sector === "Government")
              .map(datum => datum.value)
          },
          {
            name: "Private",
            color: styleConstants.categoryColors.sectorColors["Private"],
            data: data
              .filter(datum => datum.sector === "Private")
              .map(datum => datum.value)
          }
        ]}
        reversedLegend={true}
        absolute={props.absolute}
        tooltipFormatter={function() {
          return `${this.series.name} Gap: <strong>$${formatValue(
            this.y
          )}</strong><br />Share of ${this.key} Gap: <strong>${formatValue(
            this.percentage / 100,
            true
          )}</strong>`;
        }}
      />
    </div>
  );
};

CumulativeGapBySectorChart.propTypes = {
  data: PropTypes.array.isRequired,
  absolute: PropTypes.bool
};

export default memo(
  React.forwardRef((props, ref) => (
    <CumulativeGapBySectorChart innerRef={ref} {...props} />
  ))
);
